import ContractorPortalPageShell from "../components/ContractorPortalPageShell";

const ContractorProfilePage = () => (
  <ContractorPortalPageShell
    title="پروفایل"
    description="اطلاعات هویتی و پروفایل پیمانکار (در فاز بعدی تکمیل می‌شود)."
    placeholderMessage="پروفایل پورتال پیمانکار به‌زودی فعال می‌شود."
  />
);

export default ContractorProfilePage;
